/**
 * Runs an action only after the pointer has stayed on a target for `delayMs`. Scheduling again replaces the pending
 * action and `cancel` drops it, so a pointer that merely travels across other targets never triggers any of them.
 */
export interface DwellTimer {
  schedule: (action: () => void) => void;
  cancel: () => void;
}

export function createDwellTimer(delayMs: number): DwellTimer {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const cancel = () => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  };
  return {
    schedule: (action) => {
      cancel();
      timer = setTimeout(() => {
        timer = null;
        action();
      }, delayMs);
    },
    cancel,
  };
}
